import React, { useLayoutEffect } from 'react'
import { useLoaderData } from 'react-router'
import IntroPage from '../../shared/Questionnaire/IntroPage'
import PageNavContainer from '../../../state/PageNavContainer'
import OldAppHeader from '../../AppModule/App/OldAppHeader'

// -----------------------------------------------------------------------------
// Const
// -----------------------------------------------------------------------------

const PAGE_ID = `hub/are-you-getting-enough-sleep/intro`

// -----------------------------------------------------------------------------
// Factories
// -----------------------------------------------------------------------------

const HubEpworthQuizIntroModule = () => {
  const loaderData = useLoaderData()
  const [, setNav] = PageNavContainer.useContainer()
  const pageContent = loaderData?.page?.content

  useLayoutEffect(() => {
    setNav({
      pageId: PAGE_ID,
      Header: OldAppHeader,
    })
  }, [setNav])

  return (
    <IntroPage
      title={pageContent.title}
      body={pageContent.body}
      image={pageContent.image}
      linkUrl={pageContent.takeQuestionnaireButton.url}
      linkLabel={pageContent.takeQuestionnaireButton.label}
    />
  )
}

export default HubEpworthQuizIntroModule
